// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1jgRp","label":"CategoryService_label__2_-85","location":"CategoryService_location__2HSnt"};